import { ReactNode, useState } from "react";
import { SearchBoxProvided, connectSearchBox } from "react-instantsearch-core";
import { SearchContext, SearchContextInterface } from "./context";

import { initialSearchState } from "./state";

interface SearchProviderProps extends SearchBoxProvided {
  children: ReactNode;
}

const SearchProvider = ({
  children,
  refine,
}: SearchProviderProps): JSX.Element => {
  const [query, setQuery] = useState<string>("");
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false);

  const updateSearch = (query: string) => {
    setQuery(query);
    refine(query);
    setShowSuggestions(false);
  };

  const setSearchDescription = (title: string, text: string) => {
    initialSearchState.searchDescription.flavourTitle = title;
    initialSearchState.searchDescription.flavourText = text;
  };

  const ctx: SearchContextInterface = {
    ...initialSearchState,
    query,
    setQuery,
    setShowSuggestions,
    showSuggestions,
    updateSearch,
    setSearchDescription
  };

  return (
    <SearchContext.Provider value={ctx}>{children}</SearchContext.Provider>
  );
};

export default connectSearchBox(SearchProvider);
